import Vue from 'vue';
import VueRouter from 'vue-router';
import pageRoutes from './routes/page';
import userRoutes from './routes/user';
import companyRoutes from './routes/company';
import employeeRoutes from './routes/employee';
import secoRoutes from './routes/seco';
import store from '../store/store';
import i18n from '../i18n';

const Routes = pageRoutes.concat(
  userRoutes,
  companyRoutes,
  employeeRoutes,
  secoRoutes,
);

Vue.use(VueRouter);
const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'current',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.name === 'job.list' && from.name === 'job.list') {
      return;
    }
    return { x: 0, y: 0 };
  },
  routes: Routes,
});
router.beforeEach((to, from, next) => {
  // use the language from the routing param or default language
  const platformLanguages = ['de', 'it', 'en'];
  if (!platformLanguages.includes(to.params.lang)) {
    const navigatorLanguage = navigator.language.substring(0, 2);
    const newLanguage = platformLanguages.includes(navigatorLanguage) ? navigatorLanguage : 'de';
    to.params.lang = i18n.locale || newLanguage;
  }

  // const currentLanguage = i18n.locale;
  // let siteLanguage = '';

  // if (to.params.lang) {
  //   siteLanguage = to.params.lang;
  // } else if (store.state.user.language) {
  //   siteLanguage = store.state.user.language;
  // } else {
  //   siteLanguage = 'de';
  // }

  // if (currentLanguage !== siteLanguage) {
  //   store.dispatch('user/setLanguage', siteLanguage);
  // }

  // This callback runs before every route change, including on page load.
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find((r) => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find((r) => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) {
    document.title = i18n.t(nearestWithTitle.meta.titleKey);
  } else {
    document.title = i18n.t('pagedefinitions.home.title');
  }

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map((el) => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map((tagDef) => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach((key) => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
    .forEach((tag) => document.head.appendChild(tag));

  next();
  return true;
});
// export the router instance
export default router;
